import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        extra_time: "",
        half_time: "",
        match_duration: ""
      },
      imgList: [],
      ageGroupList: [],
      rules: {
        extra_time: [{
          required: true,
          message: "请输入加时赛",
          trigger: "blur"
        }],
        half_time: [{
          required: true,
          message: "请输入中场休息时间",
          trigger: "blur"
        }],
        match_duration: [{
          required: true,
          message: "请输入比赛时长",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.getTourExtraFn(data);
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTourExtraFn: function getTourExtraFn(id) {
      var _this2 = this;

      this.$api.tourExtra({
        id: id
      }).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          _this2.formData.id = data.tournament_id;
          _this2.formData.extra_time = data.extra_time;
          _this2.formData.half_time = data.half_time;
          _this2.formData.match_duration = data.match_duration;
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this3.formData));

                    _this3.$api.updateTourExtra(data).then(function (res) {
                      if (res.code == 200) {
                        _this3.$message.success('修改成功');

                        _this3.$emit('change');

                        _this3.dialogFormVisible = false;
                      } else {
                        _this3.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};